<!--
 * @Description: 
 * @Author: liulan
 * @Date: 2021-05-07 10:08:06
 * @LastEditors: liulan
 * @LastEditTime: 2021-05-27 11:06:16
 * @FilePath: \code\xingmahui_front\src\views\canEatList\components\Caption.vue
 * Copyright (C) 2021 liulan. All rights reserved.
-->
<template>
<!-- 封装的标题组件 -->
  <div :class="['caption', type ? type : '',{
      'is-plain': plain,
      'is-round': round
    }]">
    <slot v-if="$slots.default"></slot>
  </div>
</template>

<script>
  export default {
    name: 'Caption',
    data() {
      return {
      }
    },
    props: {
      type: {
        type: String,
        default: "normal"
      },
      plain: Boolean,
      round: Boolean
    }
  }
</script>

<style lang="less" scoped>
.caption {
  width: 100%;
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  background: #ffffff;
  padding: 10px 0;
  &.normal {
    background: #FFFFFF;
  }
  &.primary {
    font-size: 14px;
  }
  &.excellent {
    background: #F7F7F7;
    padding-top: 13px;
  }
  &.simple {
    background: #F7F7F7;
    padding-top: 13px;
    font-weight: normal;
  }
  &.font12 {
    font-size: 12px;
  }
  &.font16 {
    height: 20px;
    font-size: 16px;
    line-height: 20px;
  }
  &.font18 {
    height: 18px;
    line-height: 18px;
  }
  &.is-plain {
    background: rgb(163, 163, 184);
  }
  &.is-round {
    border-radius: 20px;
  }
}
</style>